import type { GridConfig } from '~/features/VirtualGrid';

export const gridConfig: GridConfig = {
    '2xl': 4,
    'xl': 4,
    'lg': 4,
    'md': 3,
    'sm': 2,
    'default': 2,
};
